import { productActionTypes } from 'store/actionTypes';
import { PRICE_TYPES } from '../../constants';
import api from 'utils/api';

export const createProduct = newData => async dispatch => {
  try {
    dispatch({ type: productActionTypes.CREATE_PRODUCT_START });
    const response = await api.post('product', newData);
    dispatch({ type: productActionTypes.CREATE_PRODUCT });
    return response;
  } catch (err) {
    dispatch({ type: productActionTypes.CREATE_PRODUCT_ERROR, payload: err });
  }
};

export const getProductDraft = () => async dispatch => {
  try {
    dispatch({ type: productActionTypes.GET_PRODUCT_DRAFT_START });
    const { data } = await api.get('product/draft');
    dispatch({ type: productActionTypes.GET_PRODUCT_DRAFT, payload: data });
  } catch (err) {
    dispatch({
      type: productActionTypes.GET_PRODUCT_DRAFT_ERROR,
      payload: err,
    });
  }
};

export const updateProductDraft = newData => async dispatch => {
  try {
    dispatch({ type: productActionTypes.UPDATE_PRODUCT_DRAFT_START });
    const { data } = await api.patch('product/draft', newData);
    dispatch({ type: productActionTypes.UPDATE_PRODUCT_DRAFT, payload: data });
  } catch (err) {
    dispatch({
      type: productActionTypes.UPDATE_PRODUCT_DRAFT_ERROR,
      payload: err,
    });
  }
};

export const changeProductDraft = newData => async dispatch => {
  try {
    dispatch({ type: productActionTypes.CHANGE_PRODUCT_DRAFT_START });
    const { status } = await api.patch('product/draft', newData);
    if (status === 200) {
      dispatch({ type: productActionTypes.CHANGE_PRODUCT_DRAFT });
    } else {
      dispatch({
        type: productActionTypes.CHANGE_PRODUCT_DRAFT_ERROR,
        payload: { message: 'Updating error, changeProductDraft' },
      });
    }
  } catch (err) {
    if (err?.response?.status === 400) {
      dispatch({
        type: productActionTypes.CHANGE_PRODUCT_DRAFT_VALIDATION_ERROR,
        payload: err.response.data,
      });
    } else {
      dispatch({
        type: productActionTypes.CHANGE_PRODUCT_DRAFT_ERROR,
        payload: err,
      });
    }
  }
};

export const updateProduct = (id, newData, priceType) => async dispatch => {
  try {
    dispatch({ type: productActionTypes.UPDATE_PRODUCT_START });
    const { data } = await api.patch(`product/${id}`, newData);
    if (priceType === PRICE_TYPES.FLEX) {
      dispatch({ type: productActionTypes.UPDATE_FLEX_PRODUCT, payload: data });
    } else {
      dispatch({ type: productActionTypes.UPDATE_FIX_PRODUCT, payload: data });
    }
  } catch (err) {
    dispatch({
      type: productActionTypes.UPDATE_PRODUCT_ERROR,
      payload: err,
    });
  }
};

export const changeProduct = (id, newData) => async dispatch => {
  try {
    dispatch({ type: productActionTypes.CHANGE_PRODUCT_START });
    const { status } = await api.patch(`product/${id}`, newData);
    if (status === 200) {
      dispatch({ type: productActionTypes.CHANGE_PRODUCT });
    } else {
      dispatch({
        type: productActionTypes.CHANGE_PRODUCT_ERROR,
        payload: { message: 'Updating error, changeProduct' },
      });
    }
  } catch (err) {
    if (err?.response?.status === 400) {
      dispatch({
        type: productActionTypes.CHANGE_PRODUCT_VALIDATION_ERROR,
        payload: err.response.data,
      });
    } else {
      dispatch({
        type: productActionTypes.CHANGE_PRODUCT_ERROR,
        payload: err,
      });
    }
  }
};

export const getAllCategories = () => async dispatch => {
  try {
    dispatch({ type: productActionTypes.GET_ALL_PRODUCT_CATEGORIES_START });
    const { data } = await api.get('category');
    dispatch({
      type: productActionTypes.GET_ALL_PRODUCT_CATEGORIES,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: productActionTypes.GET_ALL_PRODUCT_CATEGORIES_ERROR,
      payload: err,
    });
  }
};

export const publishProductDraft = () => async dispatch => {
  try {
    dispatch({ type: productActionTypes.PUBLISH_PRODUCT_DRAFT_START });
    await api.get('product/publish');
    dispatch({ type: productActionTypes.PUBLISH_PRODUCT_DRAFT });
  } catch (err) {
    dispatch({
      type: productActionTypes.PUBLISH_PRODUCT_DRAFT_ERROR,
      payload: err,
    });
  }
};

export const addProductDraftRows = newData => async dispatch => {
  try {
    dispatch({ type: productActionTypes.ADD_PRODUCT_DRAFT_ROWS_START });
    const { data } = await api.post('product', newData);
    dispatch({
      type: productActionTypes.ADD_PRODUCT_DRAFT_ROWS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: productActionTypes.ADD_PRODUCT_DRAFT_ROWS_ERROR,
      payload: err,
    });
  }
};

export const getAllFlexProducts = () => async dispatch => {
  try {
    dispatch({ type: productActionTypes.GET_ALL_FLEX_PRODUCTS_START });
    const { data } = await api.get('product/flex');
    dispatch({ type: productActionTypes.GET_ALL_FLEX_PRODUCTS, payload: data });
  } catch (err) {
    dispatch({
      type: productActionTypes.GET_ALL_FLEX_PRODUCTS_ERROR,
      payload: err,
    });
  }
};

export const getAllFixProducts = () => async dispatch => {
  try {
    dispatch({ type: productActionTypes.GET_ALL_FIX_PRODUCTS_START });
    const { data } = await api.get('product/fix');
    dispatch({ type: productActionTypes.GET_ALL_FIX_PRODUCTS, payload: data });
  } catch (err) {
    dispatch({
      type: productActionTypes.GET_ALL_FIX_PRODUCTS_ERROR,
      payload: err,
    });
  }
};

export const getProductsBySearch = (search, priceType) => async dispatch => {
  try {
    dispatch({ type: productActionTypes.GET_PRODUCTS_BY_SEARCH_START });
    const { data } = await api.get(
      `product?search=${search}&priceType=${priceType}`,
    );
    if (priceType === PRICE_TYPES.FLEX) {
      dispatch({
        type: productActionTypes.GET_FLEX_PRODUCTS_BY_SEARCH,
        payload: data,
      });
    } else {
      dispatch({
        type: productActionTypes.GET_FIX_PRODUCTS_BY_SEARCH,
        payload: data,
      });
    }
  } catch (err) {
    dispatch({
      type: productActionTypes.GET_PRODUCTS_BY_SEARCH_ERROR,
      payload: err,
    });
  }
};

export const getProductIsDraftExists = () => async dispatch => {
  try {
    dispatch({ type: productActionTypes.GET_PRODUCT_IS_DRAFT_EXISTS_START });
    const { data } = await api.get('product/user-has-draft');
    dispatch({
      type: productActionTypes.GET_PRODUCT_IS_DRAFT_EXISTS,
      payload: !!data,
    });
  } catch (err) {
    dispatch({
      type: productActionTypes.GET_PRODUCT_IS_DRAFT_EXISTS_ERROR,
      payload: err,
    });
  }
};
